var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"watch-status-badge",attrs:{"src":_vm.badgeSrc,"alt":_vm.badgeAlt}})
}
var staticRenderFns = []

export { render, staticRenderFns }